const appTemplateRouters = {
  path: "/template",
  component: () => import("@/views/layout"),
  name: "template",
  meta: { public: true, theme: "none", titleSuffix: "_管理后台" },
  children: [
    {
      path: "app-template-center",
      component: () => import("@/views/Company/AppTemplateCenter"),
      name: "app-template-center",
      meta: { public: true }
    },
    {
      path: "app-template-detail",
      component: () => import("@/views/Company/AppTemplateCenter/Detail"),
      name: "app-template-detail",
      meta: { public: true }
    }
  ]
}

export default appTemplateRouters
